module.exports = __webpack_public_path__ + "static/media/kominfo-team-8.ee8300a0.png";